import Flickity from 'flickity';

// Add equal height hack.
// Note: this requires using the `.flickity-resize {cell-class}` styled as `min-height: 100%;`

Flickity.prototype._createResizeClass = function() {
	this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

const resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
	this.element.classList.remove('flickity-resize');
	resize.call( this );
	this.element.classList.add('flickity-resize');
};

export default Flickity;
